import { useCallback } from 'react';
import { useGrid } from '../components/GridProvider/useGrid';
import type { RenderedImageRect } from '../types/types.ts';

interface GridCalculatorParams {
  imageRect: RenderedImageRect | null;
}

export const useGridCalculator = ({ imageRect }: GridCalculatorParams) => {
  const { gridSettings, gridStrategy } = useGrid();

  const getCellFromCoordinates = useCallback((x: number, y: number) => {
    return gridStrategy?.getCellFromCoordinates({ x, y }) ?? null;
  }, [gridStrategy]);

  const getCellRenderData = useCallback((row: number, col: number) => {
    return gridStrategy?.getCellRenderData({ row, col }) ?? null;
  }, [gridStrategy]);

  const getCoordsInPercent = (p: { x: number, y: number }) => {
    if (!imageRect || imageRect.width === 0 || imageRect.height === 0) return { x: 0, y: 0 };
    return {
      x: ((p.x - imageRect.x) / imageRect.width) * 100,
      y: ((p.y - imageRect.y) / imageRect.height) * 100,
    };
  };

  return {
    gridSettings,
    getCellFromCoordinates,
    getCellRenderData,
    getCoordsInPercent,
  };
};